import styled from 'styled-components'
import { useDispatch } from "react-redux"
import { useState } from 'react'
import { sendResetPassword } from 'Features/api/api'




const PasswordResetForm=()=>{
    const [passwordResetEmail, setPasswordResetEmail]=useState(
        {email:''}
    )
    const dispatch=useDispatch() 
    const handleOnchange= (e)=>{
        const{name, value}= e.target
        setPasswordResetEmail({
            ...passwordResetEmail, [name]: value}
        )
    }
    const handleSubmit= async (e)=>{
        e.preventDefault()
         dispatch(sendResetPassword(passwordResetEmail))
    }
    return(
    <Container>
    {/* <h1>Apply Loan below</h1> */}
    <p> Please provide the email address associated with your account so that you can reset your password. </p>
 <StyledForm onSubmit={handleSubmit}>

 <FormOuterRow>
            {/* <Form_Row>
                <label htmlFor="loan_name" >
                    Loan name
                </label>
                <input name="loan_name"
                    id="loan_name"
                    type="text"   placeholder="Loan name: e.g Loan 1" onChange={handleOnchange}required />
                

            </Form_Row> */}
            <Form_Row>
                <label htmlFor="email" >
                    Email:
                </label>
                <input name="email"
                    id="email"
                    type="email"   placeholder="Input your email" onChange={handleOnchange}required />
                

            </Form_Row>
            {/* <Form_Row>
                <label htmlFor="loan_type" >
                    Loan Type:
                </label>
                <select name="loan_type"  id="loan_type"
                    type="text"   placeholder="Loan type: e.g, emergency loan" onChange={handleOnchange}required>
                        <option value="">Select</option>
                       <option value="normal_loan">Normal Loan</option>
                         <option value="emergency_loan">Emergency Loan</option>

                    </select>
                

            </Form_Row> */}
  </FormOuterRow>      
<AuthButtons>
<SignUpBtn type="submit" > submit</SignUpBtn>
</AuthButtons>


 
 
 </StyledForm>
</Container>
)
}
const Container=styled.div`
display:flex;
flex-direction: column;
justify-content:flex-start;
overflow:hidden;
width:80%;
.h2{
    display:flex;
    justify-content:flex-start;
    margin-left:0px;
}
.p{
    display:flex;
    width:100%;
    justify-content:flex-start;
   

}
`
const PaymentForm=styled.form`
margin-left:0px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width: 80%;

`
const FormOuterRow=styled.div`
display:flex;
flex-direction:column;
justify-content:flex-start;
margin-bottom:10px;
width:80%;
`
const Form_Row = styled.div`

margin-bottom:10px;
margin-right:5px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width:100%;

input {
  border: none; /* Remove default border */
  border-bottom: 1px solid #353935; /* Add a single line at the bottom */
  outline: none; /* Remove outline when focused */
  width:110%; 
  
}
select {
  margin-top: 10px;  
  border: none; /* Remove default border */
  border-bottom: 1px solid #353935; /* Add a single line at the bottom */
  outline: none; /* Remove outline when focused */
  width:100%; 
  
}
label{
    font-size:12px;
}
@media (max-width: 768px) {
    .label{
        font-size:8px;
    }
    
}
`
const StyledForm=styled.form`
margin-left:0px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width:100%;
padding-left:5px;
`
const AuthButtons = styled.div`
display: flex;
align-items:center;
flex-direction:row;

margin-top:20px;
width:100%;
padding-left: 0px;
margin-left:0px;
`
const SignUpBtn = styled.button`
margin-left:80px;
display:flex;
justify-content:center;
cursor:pointer;
padding: 10px 30px;
border-radius:10px;
background-color: #E2725B;
/* background-color:red; */
color:#f9f9f9;
border:none;
width:50%;
border-color:#E2725B;
@media (max-width: 768px) {
    font-size:10px;
    padding: 5px 15px;
}
`

export default PasswordResetForm

